import { render, staticRenderFns } from "./CompanyWideProjectNotificationSettings.vue?vue&type=template&id=1cb751fc&scoped=true&"
import script from "./CompanyWideProjectNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./CompanyWideProjectNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanyWideProjectNotificationSettings.vue?vue&type=style&index=0&id=1cb751fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb751fc",
  null
  
)

export default component.exports